export default "__VITE_ASSET__DFj2eGoG__"